<template>
    <button class="btn btn-orange" :disabled="isBtnDisable" :class="[btnClass]" @click="onClick()">
        <slot></slot>
    </button>
</template>
<script>
export default {
    name: "OrangeButton",
    mixins: [],
    props: {
        customStyle: String,
        isBtnDisable: Boolean,
    },
    computed: {
        btnClass: function() {
            let btnStyle = 'default';
            if (this.customStyle != null) {
                btnStyle += this.customClass;
            }
            if(this.isBtnDisable){
                btnStyle += ' disabled';
            }
            return btnStyle;
        },
    },
    methods: {
        onClick: function(){
            this.$emit('onClick');
        },
    },
}
</script>
<style lang="scss" scoped>
    @import '@/style/base/base.scss';
    .btn-orange{
        font-size: 16px;
        width: 100%;
        height: 45px;
        max-width: 400px;
        border-radius: 10px;
        text-align: center;
        font-family: $ff-reg;
        @include max-mobile {
            min-width: auto;
            width: 100%;
        }
        &.default{
            color: white;
            background: $a-orange-f8a51b;
        }

        &.disabled{
            color: #333333;
            background: $main-disabled-btn;
        }
    }
</style>
